import React from "react";
import PropTypes from "prop-types";
import AutoDialer from "./components/AutoDialer";
import { useActiveConferenceStatus } from "./utils";
import "./styles.scss";
import getClientInstance from "../config/apollo-client";
import ASSIGN_ATTENDEE from "../mutations/assign-attendee.graphql";
import CallStatusProvider from "../call-details/CallStatusProvider";
import WaitingRoomSidebar from "../waiting-room-sidebar";
import AutoDialerContainer from "./components/AutoDialerContainer";
import { AUDIO_VISIT_TYPE } from "../waiting-room-sidebar/constants";
import { PreIntakeStatus } from "../pre-intake";

const AutoDialerInitializer = ({ consultation, currentAttendee, options = {}, forceAudioConference = false}) => {
  const apolloClient = getClientInstance();

  const { consultationId } = consultation;
  const {
    shouldDisplayAutoDialer,
    activeConferenceRS,
  } = useActiveConferenceStatus({ consultationId });

  const handleJoin = () => {
    const { externalId, roleCd } = currentAttendee;

    apolloClient.mutate({
      mutation:  ASSIGN_ATTENDEE,
      variables: {
        formData: {
          consultationId,
          actorId: externalId,
          roleCd: roleCd,
        }
      },
    });
  };

  return (
    shouldDisplayAutoDialer && (
      <React.Fragment>
        <AutoDialerContainer>
          <AutoDialer
            consultation={consultation}
            currentAttendee={currentAttendee}
            activeConferenceRS={activeConferenceRS}
            options={{
              ...options,
              onJoinCall: handleJoin,
            }}
          />
          {forceAudioConference && (
            <PreIntakeStatus consultationId={consultationId} />
          )}
        </AutoDialerContainer>

        <CallStatusProvider
          consultationId={consultationId}
          forceAudioConference={forceAudioConference}
        >
          <WaitingRoomSidebar
            consultation={consultation}
            forceAudioConference={forceAudioConference}
            visitType={AUDIO_VISIT_TYPE}
            currentUser={currentAttendee}
          />
        </CallStatusProvider>
      </React.Fragment>
    )
  );
};

AutoDialerInitializer.displayName = "AutoDialerInitializer";

AutoDialerInitializer.propTypes = {
  options: PropTypes.object,
  consultation: PropTypes.shape({
    alternatePhoneNumber: PropTypes.string,
    phoneNumber: PropTypes.string.isRequired,
    member: PropTypes.shape({
      firstNm: PropTypes.string.isRequired,
      lastNm: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  currentAttendee: PropTypes.shape({
    roleCd: PropTypes.string.isRequired,
    externalId: PropTypes.number.isRequired,
    externalTypeId: PropTypes.string.isRequired,
    phoneNumbers: PropTypes.array,
  }).isRequired,
};

export default AutoDialerInitializer;
